import { HeadingComponent } from "../../heading.component";
import { FormsTabButtonComponent } from "./forms-tab-button.component";

export class FormsTabService {
    private _currentContext: JQuery = $();

    private _classMap = {
        js: {
            dropdownButtonHeaderSelector: `.js-dropdown-button ${HeadingComponent.SELECTOR}`
        }
    };

    private _dropdownButtonHeading: HeadingComponent = null;
    private _tabButtons: Array<FormsTabButtonComponent> = [];

    private bindEvent(): void {
        this._tabButtons.forEach(tabButton => {
            tabButton.on("click")
                .subscribe((tabText: string): void => {
                    this._dropdownButtonHeading.setHtml(tabText).render();
                });
        });
    }

    private parseContext(): void {
        const dropdownButtonHeading = $(this._classMap.js.dropdownButtonHeaderSelector, this._currentContext);
        this._dropdownButtonHeading = new HeadingComponent();
        this._dropdownButtonHeading.init(dropdownButtonHeading);

        const tabButtonsContext = $(FormsTabButtonComponent.SELECTOR, this._currentContext);
        tabButtonsContext.each((index, entry) => {
            const tabButton = $(entry);
            const tabButtonComponent = new FormsTabButtonComponent();
            tabButtonComponent.init(tabButton);
            this._tabButtons.push(tabButtonComponent);
        });
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this.bindEvent();
    }
}
